/**
 * Can-Care market currency label enhancement.
 *
 * Purpose:
 * Prefix storefront price displays with the active Shopify presentment currency
 * ISO code (for example: HKD $100.00, SGD $100.00, MYR RM100.00).
 *
 * Important:
 * - Shopify Markets remains responsible for market selection and price conversion.
 * - This script changes presentation only; it never recalculates monetary values.
 * - MutationObserver support keeps AJAX cart, variant changes and GemPages prices labelled.
 */
(function () {
  'use strict';

  var config = window.CanCareCurrencyDisplay || {};
  var currencyCode = String(config.isoCode || '').trim().toUpperCase();

  if (!currencyCode) return;

  var selector = [
    '.money',
    '.gf_product-price',
    '.gf_product-compare-price',
    '.ssw-money',
    '.ssw-item-price',
    '.ssw-total-price',
    '.ssw-fave-product-price',
    '.ssw-insta-product-price',
    '.ssw-insta-product-compare-price'
  ].join(',');

  function hasCurrencyPrefix(text) {
    return new RegExp('^\\s*' + currencyCode + '(?:\\s|&nbsp;)+', 'i').test(text || '');
  }

  function labelPrice(element) {
    if (!element || element.nodeType !== 1) return;

    var text = (element.textContent || '').trim();

    if (!text || !/[0-9]/.test(text)) return;

    /*
    * Shopify may already output the ISO code at the end:
    * RM294.00 MYR
    *
    * Normalize it before adding our preferred prefix:
    * MYR RM294.00
    */
    var trailingCurrency = new RegExp(
      '\\s+' + currencyCode + '\\s*$',
      'i'
    );

    if (trailingCurrency.test(text)) {
      var cleanedText = text.replace(trailingCurrency, '').trim();

      /*
      * Price elements used by Venue/GemPages are primarily textual,
      * so replace the normalized display value.
      */
      element.textContent = currencyCode + ' ' + cleanedText;

      if (element.dataset) {
        element.dataset.cancareCurrencyLabelled = currencyCode;
      }

      return;
    }

    /*
    * Already correctly prefixed.
    */
    if (hasCurrencyPrefix(text)) {
      if (element.dataset) {
        element.dataset.cancareCurrencyLabelled = currencyCode;
      }

      return;
    }

    /*
    * Standard output such as:
    * $100.00
    * RM100.00
    */
    element.insertBefore(
      document.createTextNode(currencyCode + ' '),
      element.firstChild
    );

    if (element.dataset) {
      element.dataset.cancareCurrencyLabelled = currencyCode;
    }
  }

  function scan(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches && root.matches(selector)) {
      labelPrice(root);
    }

    if (root.querySelectorAll) {
      var nodes = root.querySelectorAll(selector);

      for (var i = 0; i < nodes.length; i++) {
        labelPrice(nodes[i]);
      }
    }
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'characterData') {
          var parent = mutation.target.parentElement;

          if (parent) {
            if (parent.dataset) {
              delete parent.dataset.cancareCurrencyLabelled;
            }

            scan(parent);
          }
        } else {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            scan(mutation.addedNodes[j]);
          }

          if (
            mutation.target &&
            mutation.target.nodeType === 1 &&
            mutation.target.matches &&
            mutation.target.matches(selector)
          ) {
            if (mutation.target.dataset) {
              delete mutation.target.dataset.cancareCurrencyLabelled;
            }

            labelPrice(mutation.target);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();